export const GET_JOURNEY_GRAPH = "app/LOCATION_JOURNEY_GRAPH/GET";
export const GET_JOURNEY_GRAPH_SUCCESS =
  "app/LOCATION_JOURNEY_GRAPH/GET_SUCCESS";
export const GET_JOURNEY_GRAPH_FAILURE =
  "app/LOCATION_JOURNEY_GRAPH/GET_FAILURE";

export const SAVE_JOURNEY_GRAPH = "app/LOCATION_JOURNEY_GRAPH/SAVE";
export const SAVE_JOURNEY_GRAPH_SUCCESS =
  "app/LOCATION_JOURNEY_GRAPH/SAVE_SUCCESS";
export const SAVE_JOURNEY_GRAPH_FAILURE =
  "app/LOCATION_JOURNEY_GRAPH/SAVE_FAILURE";

export const PUBLISH_JOURNEY_GRAPH = "app/LOCATION_JOURNEY_GRAPH/PUBLISH";
export const PUBLISH_JOURNEY_GRAPH_SUCCESS =
  "app/LOCATION_JOURNEY_GRAPH/PUBLISH_SUCCESS";
export const PUBLISH_JOURNEY_GRAPH_FAILURE =
  "app/LOCATION_JOURNEY_GRAPH/PUBLISH_FAILURE";

export const VALIDATE_JOURNEY_GRAPH = "app/LOCATION_JOURNEY_GRAPH/VALIDATE";
export const VALIDATE_JOURNEY_GRAPH_SUCCESS =
  "app/LOCATION_JOURNEY_GRAPH/VALIDATE_SUCCESS";
export const VALIDATE_JOURNEY_GRAPH_FAILURE =
  "app/LOCATION_JOURNEY_GRAPH/VALIDATE_FAILURE";
